module.exports = __webpack_public_path__ + "img/gold-star-icon.2c35ba78.svg";